var _excluded = ["path", "children", "history"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { profile } from '../../profile';

var getUrl = function getUrl() {
  return profile().aproUrl;
};

export default (function (_ref) {
  var path = _ref.path,
      children = _ref.children,
      history = _ref.history,
      props = _objectWithoutProperties(_ref, _excluded);

  if (history === false) return children;
  return /*#__PURE__*/React.createElement("a", _extends({
    href: history ? '#' : "".concat(getUrl()).concat(path),
    onClick: history ? function (e) {
      e.preventDefault();
      history.push(path);
    } : null
  }, props), children);
});